import Image from "next/image";
import { FC } from "react";
import s from "./styles.module.sass";
import LocationInCircle from "../../../../../../../public/icons/locationInCircle.svg";
import WebsiteInCircle from "../../../../../../../public/icons/websiteInCircle.svg";

type BenefitProps = {
	imageSrc: string;
	description: string;
};

export const Benefit = ({ imageSrc, description }: BenefitProps) => {
	return (
		<div className={s.benefit}>
			<div className={s.benefitImageWrapper}>
				<Image src={imageSrc} alt="Преимущество" />
			</div>
			<p>{description}</p>
		</div>
	);
};

const Benefits: FC = () => {
	return (
		<>
			<section className={`${s.modernEdPerspectives} marginedSection`}>
				<div className={s.infoBlock}>
					<h3 className={s.title}>Почему Selfschool?</h3>
					<p>
						Небольшие курсы для быстрого освоения конкретных практических навыков — тренд, который мы
						поддерживаем и развиваем. Это — удобный способ, чтобы поделиться знаниями с другим человеком в
						короткие сроки.
					</p>
				</div>

				<Benefit
					imageSrc={LocationInCircle}
					description="Персонализируем обучающие продукты и сокращаем дистанцию между учеником и преподавателем"
				/>
			</section>
			<section className={`${s.convenietPlatform} marginedSection`}>
				<Benefit
					imageSrc={WebsiteInCircle}
					description="Работаем как единый ресурс, который помогает ученикам и преподавателям быть в контакте друг с другом "
				/>
				<div className={s.infoBlock}>
					<h3 className={s.title}>В чем наша особенность?</h3>
					<p>
						Мы создали удобную платформу с навигацией, системой поиска по темам и личным кабинетом, в котором
						есть встроенный конструктор по созданию учебных программ. Вы можете смотреть лекции из любой точки
						мира и проходить программы с помощью планшета, телефона или компьютера.
					</p>
				</div>
			</section>
		</>
	);
};

export default Benefits;
